<template>
  <v-app-bar clipped-left app dense color="#FFFFFF">
    <v-app-bar-nav-icon
      v-on:click="appDrawer()"
      id="buttonDrawer"
      :style="this.$store.state.navIconSecondaryT"
    >
      <div id="nav-icon3" v-if="!this.$vuetify.theme.dark">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div id="nav-icon3" v-else>
        <span style="background: white;"></span>
        <span style="background: white;"></span>
        <span style="background: white;"></span>
        <span style="background: white;"></span>
      </div>
    </v-app-bar-nav-icon>
    <v-toolbar-title
      :style="this.$store.state.paddingLeftSecondaryT"
    >{{ (this.$store.state.titleToolbar).toUpperCase() }}</v-toolbar-title>

    <v-spacer></v-spacer>
    <!-- <v-divider
      v-if="(this.getRoutePath == true) && (this.$store.state.visible == true)"
      class="mx-3"
      inset
      vertical
    ></v-divider>
    <v-btn
      v-if="(this.getRoutePath == true) && (this.$store.state.visible == true)"
      text
      :disabled="disableButton"
      style="height: 100% !important; margin: 0 !important;"
      v-on:click="bottomSheet()"
    >
      <v-icon left dark>mdi-truck</v-icon>
      <span v-if="this.$store.state.periodDatesTitle.length > 0">
        {{
        $t("filterVehicles").toUpperCase()
        }}
      </span>
    </v-btn>-->
    <v-divider
      v-if="(this.getRoutePath == true) || (this.$store.state.visible == false)"
      class="mx-4"
      inset
      vertical
    ></v-divider>
    <v-menu
      v-model="calendarTime"
      offset-x
      scrollable
      :close-on-content-click="false"
      :max-width="this.$store.state.changeWidth"
      :style="this.$store.state.styleCalendarTitle"
      v-if="(this.getRoutePath == true) && (this.$store.state.visible == true)"
    >
      <template v-slot:activator="{ on }" v-if="this.$store.state.visible == true">
        <v-btn
          text
          v-on="on"
          :disabled="disableButton"
          :color="colorTheme"
          style="height: 100% !important; margin: 0 !important;"
        >
          <v-icon left dark>mdi-calendar</v-icon>
          {{ periodDatesTitle }}
        </v-btn>
      </template>
      <div style="width: 580px!important; display:table-cell;">
        <calendarTime></calendarTime>
      </div>
    </v-menu>
    <!-- Botonos de Administracion de operadores y telefonos -->
    <v-btn
      v-if="(this.getRoutePathAdmin == true) && (this.$store.state.visible == true)"
      text
      style="height: 100% !important; margin: 0 !important;"
      v-on:click="changeToOperator()"
    >
      <v-icon left dark>mdi-account</v-icon>
      <span>
        {{
        $t("operators").toUpperCase()
        }}
      </span>
    </v-btn>
    <v-divider
      v-if="(this.getRoutePathAdmin == true) && (this.$store.state.visible == true)"
      class="mx-3"
      inset
      vertical
    ></v-divider>
    <v-btn
      v-if="(this.getRoutePathAdmin == true) && (this.$store.state.visible == true)"
      text
      style="height: 100% !important; margin: 0 !important;"
      v-on:click="changeToMobile()"
    >
      <v-icon left dark>mdi-cellphone</v-icon>
      <span>
        {{
        $t("mobiles").toUpperCase()
        }}
      </span>
    </v-btn>
    <!-- Botones Vehicles y Templates -->
    <v-btn
      v-if="(this.getRoutePathSettingsAT) && (this.$store.state.visible == true)"
      text
      style="height: 100% !important; margin: 0 !important;"
      v-on:click="changeToVehiclesAT()"
    >
      <span>
        {{
        $t("vehicles").toUpperCase()
        }}
      </span>
    </v-btn>
    <v-divider
      v-if="(this.getRoutePathSettingsAT) && (this.$store.state.visible == true)"
      class="mx-3"
      inset
      vertical
    ></v-divider>
    <v-btn
      v-if="(this.getRoutePathSettingsAT) && (this.$store.state.visible == true)"
      text
      style="height: 100% !important; margin: 0 !important;"
      v-on:click="changeToTemplatesAT()"
    >
      <span>
        {{
        $t("templates").toUpperCase()
        }}
      </span>
    </v-btn>

    <v-menu 
      offset-y
      v-if="(this.$route.path == '/tracking') && (this.$store.state.visible == true)"
    >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            :color="colorTheme"
            dark
            v-bind="attrs"
            v-on="on"
          >
          <v-icon left dark>mdi-calendar</v-icon>
            {{days}}
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            @click="periodSelected(item)"
          >
            <v-list-item-title v-if="index == 0">{{ item.value }}</v-list-item-title>
            <v-list-item-title v-else>{{ item.value }} {{ $t("days") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    <v-divider
      class="mx-5"
      inset
      vertical
      v-if="(this.$route.path == '/tracking') && (this.$store.state.visible == true)"
    ></v-divider>
    <v-menu 
      offset-y
      v-if="(this.$route.path == '/tracking') && (this.$store.state.visible == true)"
    >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            :color="colorTheme"
            dark
            v-bind="attrs"
            v-on="on"
          >
          <v-icon left dark>mdi-map-clock-outline</v-icon>
            {{minutes}}
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in itemsForMinutes"
            :key="index"
            @click="minutesSelected(item)"
          >
            <v-list-item-title v-if="index == 0">{{ item.value }} {{ $t("minutes").slice(0, -1) }}</v-list-item-title>
            <v-list-item-title v-else>{{ item.value }} {{ $t("minutes") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-divider
      class="mx-5"
      inset
      vertical
      v-if="(this.getRoutePathAFOrT == true) && (this.$store.state.visible == true)"
    ></v-divider>
    <div
      :style="'font-size:' + this.$store.state.fontsizeTxtt + ';'"
      v-if="this.getRoutePathAFOrT"
    >
      <v-row style="font-weight: bold;">{{this.$store.state.dealerName}}</v-row>
      <v-row>{{this.$store.state.clientName}}</v-row>
    </div>
    <v-menu bottom left style="z-index: 15;">
      <template v-slot:activator="{ on }">
        <v-btn :color="colorTheme" icon text v-on="on" small v-if="visible == false" class="pl-3">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <!-- <v-list-item-title>
          <v-btn
            v-if="this.getRoutePath == true"
            :disabled="disableButton"
            text
            v-on:click="bottomSheet()"
          >
            <v-icon left dark>mdi-truck</v-icon>
          </v-btn>
        </v-list-item-title>-->
        <v-list-item-title>
          <v-btn
            v-if="this.getRoutePath == true"
            text
            :disabled="disableButton"
            :color="colorTheme"
            v-on:click="openCalendar()"
          >
            <v-icon left dark>mdi-calendar</v-icon>
          </v-btn>
        </v-list-item-title>
        <v-list-item-title>
          <v-btn text v-on:click="settings()">
            <v-icon left dark>mdi-settings</v-icon>
          </v-btn>
        </v-list-item-title>
        <v-list-item-title>
          <v-btn v-if="this.getRoutePathAdmin == true" text v-on:click="changeToOperator()">
            <v-icon left dark>mdi-account</v-icon>
          </v-btn>
        </v-list-item-title>
        <v-list-item-title>
          <v-btn v-if="this.getRoutePathAdmin == true" text v-on:click="changeToMobile()">
            <v-icon left dark>mdi-cellphone</v-icon>
          </v-btn>
        </v-list-item-title>
        <v-list-item-title>
          <v-btn v-if="$route.name == 'tracking'" text v-on:click="openPeriod()">
            <v-icon left dark>mdi-calendar</v-icon>
          </v-btn>
        </v-list-item-title>
        <v-list-item-title>
          <v-btn v-if="$route.name == 'tracking'" text v-on:click="openMinutes()">
            <v-icon left dark>mdi-map-clock-outline</v-icon>
          </v-btn>
        </v-list-item-title>
        <v-list-item-title>
          <v-btn v-if="$route.name == 'settingsAT' || 'settingsAT/verifyConfiguration'" text v-on:click="changeToVehiclesAT()">
            <v-icon left dark>mdi-car-hatchback</v-icon>
          </v-btn>
        </v-list-item-title>
        <v-list-item-title>
          <v-btn v-if="$route.name == 'settingsAT' || 'settingsAT/verifyConfiguration'" text v-on:click="changeToTemplatesAT()">
            <v-icon left dark>mdi-note-text</v-icon>
          </v-btn>
        </v-list-item-title>
      </v-list>
    </v-menu>
    <!-- mobile -->
    <v-dialog
      v-model="showPeriod"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      v-if="this.$store.state.visible == false"
    >
      <v-card>
          <v-toolbar
            color="#424242" 
            dark
          >
            <v-btn
              icon
              dark
              @click="showPeriod = false"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title>{{ $t("predDays") }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-list>
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            @click="periodSelected(item)"
          >
            <v-list-item-title v-if="index == 0">{{ item.value }}</v-list-item-title>
            <v-list-item-title v-else>{{ item.value }} {{ $t("days") }}</v-list-item-title>
          </v-list-item>
        </v-list>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showMinutes"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      v-if="this.$store.state.visible == false"
    >
      <v-card>
          <v-toolbar
            color="#424242" 
            dark
          >
            <v-btn
              icon
              dark
              @click="showMinutes = false"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title>{{ $t("predMinutes") }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container>
          <v-list>
          <v-list-item
            v-for="(item, index) in itemsForMinutes"
            :key="index"
            @click="minutesSelected(item)"
          >
            <v-list-item-title v-if="index == 0">{{ item.value }} {{ $t("minutes").slice(0, -1) }}</v-list-item-title>
            <v-list-item-title v-else>{{ item.value }} {{ $t("minutes") }}</v-list-item-title>
          </v-list-item>
        </v-list>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>

<script>
import i18n from "@/plugins/i18n";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "secondaryToolbar",
  components: {
    calendarTime: () => import("@/components/calendarTime")
  },
  data: () => ({
    fav: true,
    message: false,
    hints: true,
    menu: false,
    items: [
      { value: i18n.t("all") },
      { value: 7 },
      { value: 14 },
      { value: 30 },
      { value: 60 },
      { value: 90 },
      { value: 120 },
      { value: 365 },
    ],
    days: "",
    showPeriod: false,
    itemsForMinutes: [
      { value: 1 },
      { value: 5 },
      { value: 10 },
      { value: 15 },
      { value: 20 },
      { value: 30 },
    ],
    minutes: "",
    showMinutes: false
  }),
  computed: {
    ...mapState([
      "periodDatesTitle",
      "colorTheme",
      "setLocale",
      "disableButton",
      "periodDatesTitleAF"
    ]),
    visible: {
      get: function() {
        return this.$store.state.visible;
      },
      set: function() {}
    },
    mini: {
      get: function() {
        return this.$store.state.mini;
      },
      set: function() {
        this.$store.commit("appDrawer");
      }
    },
    calendarTime: {
      get: function() {
        return this.$store.state.calendarTime;
      },
      set: function(val) {
        this.$store.commit("calendarTime", val);
      }
    },
    getRoutePath() {
      var path = this.$route.name;
      if (this.$store.state.visible) {
        if (
          path == "dashboard" ||
          path == "vehiclesExceptions" ||
          path == "accountBalancePage" ||
          path == "individualFuel"
        ) {
          return true;
        }
      } else {
        if (
          path == "dashboard" ||
          path == "vehiclesExceptions" ||
          path == "accountBalancePage"
        ) {
          return true;
        }

      }
      return false;
    },
    getRoutePathAdmin() {
      var path = this.$route.name;
      if (path == "operator" || path == "mobilePhone") {
        return true;
      }

      return false;
    },
    getRoutePathAFOrT() {
      var path = this.$route.name;
      if (path == "individualFuel" || path == "tracking") {
        return true;
      }

      return false;
    },
    getRoutePathSettingsAT() {
      var path = this.$route.name;
      if (path == "settingsAT" || path == "verifyConfiguration") {
        return true;
      }

      return false;
    }
  },
  created() {
    this.days = localStorage.getItem("numberOfDaysT") == undefined || localStorage.getItem("numberOfDaysT") == null
      ? 30 + ' ' + this.$i18n.t("days")
      : localStorage.getItem("numberOfDaysT") == this.$i18n.t("all") ? this.$i18n.t("all") : localStorage.getItem("numberOfDaysT") + ' ' + this.$i18n.t("days");
    this.minutes = localStorage.getItem("minutesT") == undefined || localStorage.getItem("minutesT") == null
      ? 5 + ' ' + this.$i18n.t("minutes")
      : localStorage.getItem("minutesT") == 1 ? localStorage.getItem("minutesT") + ' ' + this.$i18n.t("minutes").slice(0, -1) : localStorage.getItem("minutesT") + ' ' + this.$i18n.t("minutes");
  },
  mounted() {
    this.appDrawer();
  },
  methods: {
    periodSelected(item) {
      localStorage.setItem("numberOfDaysT", item.value);
      this.showPeriod = false;
      this.$store.dispatch("fleetLastPosition");
      this.days = item.value == this.$i18n.t("all") ? item.value : item.value + ' ' + this.$i18n.t("days");
    },
    minutesSelected(item){
      localStorage.setItem("minutesT", item.value);
      this.showMinutes = false;
      this.$store.dispatch("fleetLastPosition");
      this.minutes = item.value == 1 ? item.value + ' ' + this.$i18n.t("minutes").slice(0, -1) : item.value + ' ' + this.$i18n.t("minutes");
    },
    appDrawer() {
      var vm = this;
      document
        .getElementById("buttonDrawer")
        .addEventListener("click", function getDetails(evt) {
          vm.$store.commit("appDrawer");
          evt.stopImmediatePropagation();
        });
      var AppDrawer = document.getElementById("AppDrawer");
      if (AppDrawer != null) {
        document
          .getElementById("AppDrawer")
          .addEventListener("click", function getDetails(evt) {
            evt.stopImmediatePropagation();
          });
      }
      document.addEventListener("click", function(evt) {
        if (!vm.$store.state.mini) {
          vm.$store.commit("appDrawer");
        }
        evt.stopPropagation();
      });
    },
    bottomSheet() {
      this.$store.commit("bottomSheet");
    },
    settings() {
      this.$store.commit("settings");
    },
    openCalendar() {
      this.$store.commit("calendarTime", true);
    },
    changeToOperator() {
      this.$router.replace({ name: "operator" });
    },
    changeToMobile() {
      this.$router.replace({ name: "mobilePhone" });
    },
    openPeriod() {
      this.showPeriod = true;
    },
    openMinutes() {
      this.showMinutes = true;
    },
    changeToVehiclesAT() {
      this.$store.commit("showVehiclesAT", true);
      localStorage.setItem("showVehiclesAT", true);
      if (this.$route.path == "/settingsAT/verifyConfiguration") {
        this.$router.replace({ name: "settingsAT" });
      }
    },
    changeToTemplatesAT() {
      this.$store.commit("showVehiclesAT", false);
      localStorage.setItem("showVehiclesAT", false);
      if (this.$route.path == "/settingsAT/verifyConfiguration") {
        this.$router.replace({ name: "settingsAT" });
      }
    }
  },
  watch: {
    mini() {
      var element = document.getElementById("nav-icon3");
      element.classList.toggle("open");
    }
  }
};
</script>

<style scoped>
#nav-icon3 {
  width: 19px;
  height: 13px;
  position: relative;
  margin: 12px auto;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -o-transition: 0.5s ease-in-out;
  transition: 0.5s ease-in-out;
  cursor: pointer;
}

#nav-icon3 span {
  display: block;
  position: absolute;
  height: 2px;
  width: 100%;
  background: black;
  border-radius: 1px;
  opacity: 1;
  left: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: 0.25s ease-in-out;
  -moz-transition: 0.25s ease-in-out;
  -o-transition: 0.25s ease-in-out;
  transition: 0.25s ease-in-out;
}

/* Icon 3 */

#nav-icon3 span:nth-child(1) {
  top: 0px;
}

#nav-icon3 span:nth-child(2),
#nav-icon3 span:nth-child(3) {
  top: 5px;
}

#nav-icon3 span:nth-child(4) {
  top: 10px;
}

#nav-icon3.open span:nth-child(1) {
  top: 18px;
  width: 0%;
  left: 50%;
}

#nav-icon3.open span:nth-child(2) {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}

#nav-icon3.open span:nth-child(3) {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

#nav-icon3.open span:nth-child(4) {
  top: 18px;
  width: 0%;
  left: 50%;
}
</style>
